import { fileToBase64 } from "@/shared/lib";

export const processFilesForMessage = async (files: File[]): Promise<{
  filesBase64: string[];
  blobUrls: string[];
}> => {
  const filesBase64: string[] = [];
  const blobUrls: string[] = [];

  for (const file of files) {
    try {
      const base64 = await fileToBase64(file);
      filesBase64.push(base64);
      blobUrls.push(URL.createObjectURL(file));
    } catch (err) {
      console.error("Failed to process file for message", file, err);
    }
  }

  return { filesBase64, blobUrls };
};